import ProfileMe from './ProfileMe';

export default ProfileMe;
